module.exports = __webpack_public_path__ + "files/10806efe7a660323ab79018176f88410.png";